import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ButtonGroup,
  Text,
  Modal,
} from '../../components';

const propTypes = {
  closeHandler: PropTypes.func.isRequired,
  deleteError: PropTypes.string,
  deleteHandler: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

const defaultProps = {
  deleteError: null,
};

export default function DeleteContent({
  isOpen,
  deleteHandler,
  closeHandler,
  deleteError,
}) {
  return (
    <Modal title="Delete Content" isOpen={isOpen} onClose={closeHandler}>
      <Modal.Body>
        <Text as="h5">
          Are you sure you want to delete the selected content permanently?
        </Text>
        {deleteError && <Text color="red">{deleteError}</Text>}
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Button onClick={closeHandler}>Cancel</Button>
          <Button variant="danger" primary onClick={deleteHandler}>Delete</Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
}

DeleteContent.propTypes = propTypes;
DeleteContent.defaultProps = defaultProps;
